import { render } from "./total_display.vue?vue&type=template&id=44ef7a4c"
import script from "./total_display.vue?vue&type=script&lang=js"
export * from "./total_display.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__